import { DocumentDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetAenderungsantragAttachmentsResolver  {
  constructor(protected anfrageService: AnfrageService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService, protected portalContextService: PortalContextService) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DocumentDisplayModel[] | null | undefined> {
    let id: string = <string>route.params['id'];
    let sectionId: string = <string>route.params['abschnittid'];

    await this.unfinishedHttpMethodsService.waitByUrl(state.url);

    return this.anfrageService.apiAnfrageAnfrageIdAttachmentGet({ anfrageId: id, loadContent: false, loadDocumentType: true, aenderungsantragId: sectionId }).pipe(map(response => {
      if (response) {
        this.portalContextService.CurrentAnfrage.attachments = response;

        return response;
      }

      return undefined;
    })).toPromise();
  }
}